import Icon from '@components/common/Icon';

const achievements = [
  {
    year: '2021',
    title: 'ABRSM Grade 5 Violin Performance',
    description: 'I successfully passed ABRSM Grade 5 Violin Performance examination with distinction',
    icon: '🎻',
  },
  {
    year: '2023',
    title: 'Music Theory Grade 5 Certification',
    description: 'I completed ABRSM Music Theory Grade 5 with comprehensive understanding',
    icon: '📖',
  },
  {
    year: '2020',
    title: 'School Recital Performance',
    description: 'I performed in ISM auditorium showcasing classical repertoire to school community',
    icon: '🎼',
  },
  {
    year: '2025',
    title: 'Continued Musical Excellence',
    description: 'I actively participate in school music programs and continue personal performances',
    icon: '⭐',
  },
];

const AchievementsSection = () => {
  return (
    <section
      className="py-20 px-4 sm:px-6 lg:px-8"
      style={{
        backgroundColor: 'var(--color-body-bg)',
      }}
    >
      <div className="container mx-auto max-w-7xl">
        {/* Section Header */}
        <div className="text-center mb-16 space-y-4">
          <div className="flex items-center justify-center gap-3 mb-4">
            <Icon name="music" size="xl" style={{ color: 'var(--color-accent-6)' }} />
            <h2
              className="text-4xl sm:text-5xl font-heading font-bold tracking-tight"
              style={{ color: 'var(--color-heading)' }}
            >
              Musical Journey
            </h2>
          </div>
          <p
            className="text-lg max-w-3xl mx-auto"
            style={{ color: 'var(--color-subtle)' }}
          >
            Key milestones and achievements in musical development
          </p>
        </div>

        {/* Timeline */}
        <div className="space-y-8">
          {achievements.map((achievement, index) => (
            <div key={index} className="relative">
              {/* Timeline line */}
              {index !== achievements.length - 1 && (
                <div
                  className="absolute left-6 sm:left-8 top-20 sm:top-24 h-12 sm:h-16 w-0.5"
                  style={{ backgroundColor: 'var(--color-accent-3)' }}
                />
              )}

              {/* Content */}
              <div className="flex gap-4 sm:gap-6">
                {/* Timeline dot */}
                <div className="flex flex-col items-center pt-2">
                  <div
                    className="w-12 h-12 sm:w-16 sm:h-16 rounded-full flex items-center justify-center text-xl sm:text-2xl shadow-card transition-transform duration-300 hover:scale-110 flex-shrink-0"
                    style={{
                      backgroundColor: 'var(--color-accent-2)',
                      borderColor: 'var(--color-accent-6)',
                      borderWidth: '2px',
                      borderStyle: 'solid',
                    }}
                  >
                    {achievement.icon}
                  </div>
                </div>

                {/* Achievement Card */}
                <div
                  className="flex-1 p-4 sm:p-6 rounded-2xl shadow-card transition-all duration-300 hover:shadow-card-hover"
                  style={{
                    backgroundColor: 'var(--color-card-bg)',
                    borderColor: 'var(--color-card-border)',
                    borderWidth: '1px',
                    borderStyle: 'solid',
                  }}
                >
                  <div className="flex flex-col sm:flex-row sm:items-baseline sm:justify-between sm:gap-4 mb-2 sm:mb-3">
                    <h3
                      className="text-lg sm:text-2xl font-bold"
                      style={{ color: 'var(--color-heading)' }}
                    >
                      {achievement.title}
                    </h3>
                    <span
                      className="inline-block px-3 sm:px-4 py-1 rounded-full text-xs sm:text-sm font-semibold mt-2 sm:mt-0 self-start"
                      style={{
                        backgroundColor: 'var(--color-accent-2)',
                        color: 'var(--color-accent-7)',
                      }}
                    >
                      {achievement.year}
                    </span>
                  </div>
                  <p
                    className="text-base sm:text-lg"
                    style={{ color: 'var(--color-subtle)' }}
                  >
                    {achievement.description}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* CTA Section */}
        <div
          className="mt-12 sm:mt-16 p-6 sm:p-8 rounded-2xl text-center"
          style={{
            background: `linear-gradient(135deg, var(--color-accent-2), var(--color-accent-1))`,
          }}
        >
          <h3
            className="text-lg sm:text-2xl font-bold mb-2 sm:mb-3"
            style={{ color: 'var(--color-accent-7)' }}
          >
            "Music gives a soul to the universe, wings to the mind, flight to the imagination"
          </h3>
          <p
            className="text-base sm:text-lg"
            style={{ color: 'var(--color-accent-8)' }}
          >
            — Plato
          </p>
        </div>
      </div>
    </section>
  );
};

export default AchievementsSection;
